/* wellio-cart.js - cross-sell Akkermansia + Package Protection (opt-in)
   Pocket (#WellioCartAddons) tu tao neu trang khong render san, roi keo markup
   ve bang Section Rendering API - vi layout render thang snippet cart-drawer.

   Toc do: cart/add.js va cart/change.js nhan tham so `sections`, tra ve HTML
   section NGAY trong cung response -> 1 round-trip thay vi 2. Cong them
   optimistic UI (an card cross-sell / doi nut ngay khi bam) nen khong con do tre.

   24/09: add-ons (cross-sell + protection) chuyen tu .drawer__footer VAO vung cuon
   <cart-drawer-items> (sau form). Ly do: footer co dinh cao ~550px tren mobile ->
   iPhone SE / webview FB (cao 553-667px) khong con cho cho dong san pham (bi che het).
   Footer gio chi con subtotal + guarantee + checkout + icon thanh toan (~260px). */
(function () {
  'use strict';

  var PROTECT_SEL = '[data-wellio-protect]';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var lock = false;
  var busy = false;
  var timer = null;
  var obs = null;

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function pocket() {
    var p = document.getElementById('WellioCartAddons');
    if (!p) {
      if (!document.body) return null;
      p = document.createElement('div');
      p.id = 'WellioCartAddons';
      p.hidden = true;
      p.setAttribute('data-sig', '');
      document.body.appendChild(p);
    }
    return p;
  }

  function drawerEl() { return document.getElementById('CartDrawer'); }

  function setBusy(on) {
    busy = on;
    var d = drawerEl();
    if (d) d.classList.toggle('wellio-busy', on);
  }

  function decorate() {
    var d = drawerEl();
    var p = pocket();
    if (!d) return;

    lock = true;
    try {
      var footer = d.querySelector('.drawer__footer');
      var scroller = d.querySelector('cart-drawer-items');
      var ctas = d.querySelector('.cart__ctas');

      /* host nam trong vung cuon (sau form) - cuon cung dong san pham */
      if (p && scroller) {
        var host = d.querySelector('.wellio-addons-host');
        if (host && host.parentNode !== scroller) { host.parentNode.removeChild(host); host = null; }
        if (!host) {
          host = document.createElement('div');
          host.className = 'wellio-addons-host';
          scroller.appendChild(host);
        }
        if (host.getAttribute('data-sig') !== p.getAttribute('data-sig')) {
          host.innerHTML = p.innerHTML;
          host.setAttribute('data-sig', p.getAttribute('data-sig') || '');
        }
      }

      var h = d.querySelector('.totals__total');
      if (h && h.textContent.trim() !== 'Subtotal') h.textContent = 'Subtotal';

      if (ctas && footer && !d.querySelector('.wellio-guarantee')) {
        var g = document.createElement('p');
        g.className = 'wellio-guarantee';
        g.textContent = '✓ Backed by our 90-day money-back guarantee';
        ctas.parentNode.insertBefore(g, ctas);
      }
    } finally {
      setTimeout(function () { lock = false; }, 0);
    }
  }

  /* Ap HTML section lay tu response cua cart/add.js hoac cart/change.js */
  function applySections(secs) {
    if (!secs) return;
    /* khoa observer trong suot qua trinh thay innerHTML, neu khong no se ban
       them mot lan sync() thua (~250ms) va lam host nhay lai */
    lock = true;
    try {
      applyInner(secs);
    } finally {
      setTimeout(function () { lock = false; }, 0);
    }
  }

  function applyInner(secs) {
    var doc = new DOMParser().parseFromString(secs['cart-drawer'] || '', 'text/html');

    var freshDrawer = doc.getElementById('CartDrawer');
    var cur = drawerEl();
    if (freshDrawer && cur) cur.innerHTML = freshDrawer.innerHTML;

    var freshPocket = doc.getElementById('WellioCartAddons');
    var p = pocket();
    if (freshPocket && p) {
      p.innerHTML = freshPocket.innerHTML;
      p.setAttribute('data-sig', freshPocket.getAttribute('data-sig') || '');
    }

    var host = document.querySelector('cart-drawer');
    if (host) host.classList.toggle('is-empty', doc.querySelector('cart-drawer-items.is-empty') !== null);

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && secs['cart-icon-bubble']) {
      var b = new DOMParser().parseFromString(secs['cart-icon-bubble'], 'text/html');
      var inner = b.querySelector('.shopify-section');
      if (inner) bubble.innerHTML = inner.innerHTML;
    }
    decorate();
  }

  /* Chi dong bo lai pocket (khi Dawn tu render lai drawer) */
  function sync() {
    return fetch(root() + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var doc = new DOMParser().parseFromString(data['cart-drawer'] || '', 'text/html');
        var fresh = doc.getElementById('WellioCartAddons');
        var p = pocket();
        if (fresh && p && fresh.getAttribute('data-sig') !== p.getAttribute('data-sig')) {
          p.innerHTML = fresh.innerHTML;
          p.setAttribute('data-sig', fresh.getAttribute('data-sig') || '');
        }
        decorate();
      })
      .catch(function () {});
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 250);
  }

  function refresh() {
    return fetch(root() + '?sections=' + SECTIONS)
      .then(function (r) { return r.json(); })
      .then(applySections)
      .catch(function () {});
  }

  function getCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* Tra ve luon sections trong cung 1 request */
  function addLine(variantId) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: SECTIONS,
        sections_url: window.location.pathname
      })
    }).then(function (r) { return r.json(); });
  }

  function removeVariant(variantId) {
    return getCart().then(function (cart) {
      var line = -1;
      cart.items.forEach(function (it, i) { if (it.variant_id === variantId) line = i + 1; });
      if (line === -1) return null;
      return fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: 0,
          sections: SECTIONS,
          sections_url: window.location.pathname
        })
      }).then(function (r) { return r.json(); });
    });
  }

  function done(res) {
    if (res && res.sections) applySections(res.sections);
    else return refresh();
  }

  function cleanupProtection() {
    var box = document.querySelector(PROTECT_SEL);
    if (!box) return Promise.resolve();
    var id = Number(box.getAttribute('data-wellio-protect'));
    return getCart().then(function (cart) {
      var has = cart.items.some(function (i) { return i.variant_id === id; });
      var others = cart.items.filter(function (i) { return i.variant_id !== id; });
      if (has && others.length === 0) return removeVariant(id).then(done);
    });
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest ? e.target.closest(PROTECT_SEL) : null;
    if (!box || busy) return;
    var id = Number(box.getAttribute('data-wellio-protect'));
    setBusy(true);
    Promise.resolve(box.checked ? addLine(id) : removeVariant(id))
      .then(done)
      .catch(function () {})
      .then(function () { setBusy(false); });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wellio-xsell-add]') : null;
    if (!btn || busy) return;
    e.preventDefault();

    /* optimistic: phan hoi ngay, khong doi server */
    btn.disabled = true;
    btn.textContent = '✓ Added';
    var card = btn.closest('.wellio-xsell');
    if (card) card.classList.add('wellio-xsell--done');

    setBusy(true);
    addLine(Number(btn.getAttribute('data-wellio-xsell-add')))
      .then(done)
      .catch(function () {
        /* that bai thi tra card ve nhu cu */
        if (card) card.classList.remove('wellio-xsell--done');
        btn.disabled = false;
        btn.textContent = '+ Add';
      })
      .then(function () { setBusy(false); });
  });

  function watch() {
    var d = drawerEl();
    if (!d || obs) return;
    obs = new MutationObserver(function () { if (!lock) scheduleSync(); });
    obs.observe(d, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('cart-remove-button')) {
      setTimeout(cleanupProtection, 1000);
    }
  });

  function boot() { pocket(); decorate(); watch(); sync(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
